import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';

export function SensorBox({ icon, value, tooltipText }) {
  if (value === 'N/A') {
    return null;
  }
  return (
    <Tooltip placement="top" title={tooltipText}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          gap: 1,
          alignItems: 'center',
          width: '95px',
          justifyContent: 'center',
          cursor: 'help',
        }}
      >
        {icon && React.cloneElement(icon, { fontSize: 'small' })}
        <Typography width="75px" textAlign="center" fontSize="0.70rem">
          {value}
        </Typography>
      </Box>
    </Tooltip>
  );
}
